import classNames from "classnames";
import Footer from "components/Footer";
import SwitchSelectorBox from "components/Header/SwitchSelector";
import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { useRecoilState } from "recoil";
import { productKeyAtom, userInfoAtom } from "src/atoms";
import CommonModalsProvider from "src/context/Modal/Common/CommonModal.provider";
import { useIsOciProduct } from "src/hooks/recoil/useIsOciProduct";
import { useRouter } from "src/hooks/useRouter";
import { getCookie, setCookie } from "src/utils/cookie";
interface CommonLayoutProps {
  children: React.ReactNode;
}

// 모든 사용자 접근가능 (단 로그인 되어있으면 console로 이동)
const CommonLayout: React.FC<CommonLayoutProps> = ({ children }) => {
  // useAuth();
  const { currentPath, goConsole, goLogin, goHome, goTermsComp, lang } =
    useRouter();
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const [visibility, setVisibility] = React.useState(true);
  const [productKey, setProductKey] = useRecoilState(productKeyAtom);
  const { isOciProduct } = useIsOciProduct();
  const [searchParams] = useSearchParams();
  const product = searchParams.get("product");
  const [showNotice, setShowNotice] = React.useState(true);

  useEffect(() => {
    const closeTodayNotice = getCookie({ name: "closeTodayTermsNotice" });
    if (closeTodayNotice === "YES") {
      setShowNotice(false);
    }
  }, []);

  const closeNoticeToday = (e: React.MouseEvent) => {
    e.stopPropagation();
    const timestamp = new Date().getTime();
    const expire = timestamp + 1000 * 60 * 60 * 24;
    const expireDate = new Date(expire);
    setCookie({
      name: "closeTodayTermsNotice",
      value: "YES",
      options: { path: "/", expires: expireDate },
    });
    setShowNotice(false);
  };

  const closeNotice = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowNotice(false);
  };
  useEffect(() => {
    const querystring = window.location.search.substr(1).split("?");
    const params = new URLSearchParams(querystring[0]);
    const cloudUserInfo = JSON.parse(
      localStorage.getItem("cloudUserInfo") as string,
    );
    if (cloudUserInfo?.userInfo) {
      setUserInfo({ ...cloudUserInfo?.userInfo });
    }
    if (params.has("resultMsg")) {
      alert(params.get("resultMsg"));
      goConsole();
    }
    // 임시로 resultmsg도 처리 (추후 제거예정)
    if (params.has("resultmsg")) {
      alert(params.get("resultmsg"));
      goConsole();
    }
    if (params.has("successMsg")) {
      alert(params.get("successMsg"));
      goConsole();
    }
    if (params.has("errorMsg")) {
      alert(params.get("errorMsg"));
    }
    // if (isLanguageRouteInit) languageRouteInit();
  }, []);
  useEffect(() => {
    if (isOciProduct) {
      if (
        currentPath.includes("/terms") ||
        currentPath.includes("/termsComp")
      ) {
        setVisibility(true);
      } else setVisibility(false);
    } else {
      setVisibility(true);
    }
  }, [isOciProduct]);
  useEffect(() => {
    // 제품 세팅 안돼있으면 홈으로 이동
    // console.log("productKey", productKey);
    // console.log("currentPath", currentPath);
    if (!productKey && !product) {
      // 약관 페이지는 제품 선택 없이도 접근 가능해야 하므로 홈 리다이렉트 제외
      if (
        currentPath.includes("/terms") ||
        currentPath.includes("/termsComp") ||
        currentPath.includes("/privacyComp") ||
        currentPath.includes("/pay/card")
      ) {
        return;
      }
      goHome();
    }
  }, [productKey]);
  const isHeaderHidden =
    isOciProduct &&
    (currentPath.includes("/terms") || currentPath.includes("/termsComp"));
  const { t } = useTranslation();
  return (
    <CommonModalsProvider>
      <div
        className="common-layout"
        style={{ visibility: !visibility ? "hidden" : "visible" }}
      >
        <div className="common-layout__body">
          {/* {showNotice && lang === "ko" && (
            <div className={classNames("mainNoticeBox")} >
              <div>
                <span>{"[공지] 서비스 "}</span>
                <a href={`/${lang}/termsComp`} target="_blank" className="noticeLink">이용약관</a>&nbsp;및&nbsp;<a href={`/${lang}/privacyComp`} target="_blank" className="noticeLink">개인정보 처리방침</a>&nbsp;개정 안내
              </div>
              <div className="closeText" onClick={closeNoticeToday}>
                <span>
                  {t("navBar.notifications.close")}
                </span>
              </div>
              <div className="closeButton" onClick={closeNotice}>
                <a >
                  <i className="image" />
                </a>
              </div>
            </div>
          )} */}
          <div
            style={{
              // padding: "27px 26.15px",
              padding: "16px 30px",
              height: "85px",
              display: isHeaderHidden ? "none" : "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              borderBottom: "1px solid #E4E4E7",
            }}
          >
            <a onClick={goHome}>
              <div className="icon_fasoo main" />
            </a>
          </div>

          <SwitchSelectorBox />
          {children}
        </div>
        {!isOciProduct && <Footer />}
      </div>
    </CommonModalsProvider>
  );
};

export default CommonLayout;
